var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m13.995 3.936 7.5 6.563H3V9h14.505l-4.5-3.935zM2.25 13.499H21V15H6.75l4.2 3.15-.9 1.2z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }